import _ from "lodash";
import { ICompanyInfo } from "../services/types/LeadRequisitionType";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const convertComapanyData = (data: any, staticData: any, dunsParam?: string) => {
  const hq =
    data?.global_ultimate_country_name === "USA"
      ? "United States"
      : getCountryName(data?.global_ultimate_country_name, staticData);
  return {
    duns: data.duns ?? dunsParam,
    legalNameOfBusiness: data?.business_name ?? "",
    registerAddress: {
      streetName: data?.street_address ?? "",
      city: data?.city_name ?? "",
      state: data?.state_or_province_abbreviation ?? "",
      country: hq ?? "",
      zipcode: data?.postal_code ?? "",
    },
    headquaterCountry: hq,
    global_ultimate_country_name: hq,
    industryBasic: data?.industry ?? "",
    industry: "",
    address: data?.address ?? "",
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const convertComapaniesArrayData = (companiesDetails: any, staticData: any) => {  
  const companies: ICompanyInfo[] = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _.forEach(companiesDetails, (data: any) => {
    const hq =
      data?.global_ultimate_country_name === "USA"
        ? "United States"
        : getCountryName(data?.global_ultimate_country_name, staticData);
    const companyData: ICompanyInfo = {
      duns: data.duns,
      legalNameOfBusiness: data?.business_name ?? "",
      registerAddress: {
        streetName: data?.street_address ?? "",
        city: data?.city_name ?? "",
        state: data?.state_or_province_abbreviation ?? "",
        country: hq ?? "",
        zipcode: data?.postal_code ?? "",
      },
      headquaterCountry: hq,
      global_ultimate_country_name: hq,
      industryBasic: data?.industry ?? "",
      industry: "",
      address: data?.address ?? "",
    };
    companies.push(companyData);
  });
  return companies;
};
export const getCountryName = (item: any, staticData: any) => {
  return Object.keys(staticData.countries || {}).filter((key: any) => key.toUpperCase() === item.toUpperCase())[0];
}

export const createAddress = (data: ICompanyInfo) => {
  return data?.registerAddress?.streetName + ", " + data?.registerAddress?.city + ", " + data?.registerAddress?.state + ", " + data?.global_ultimate_country_name + ", " + data?.registerAddress?.zipcode;
};

